<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick" :before-leave="tabsBefore">
        <el-tab-pane label="基本信息" name="first">
          <BaseInfo ref="baseInfoRef" :isBed="isBed" v-model="form" :row="form" @success="successHandler"
            :model="model"></BaseInfo>
        </el-tab-pane>
        <el-tab-pane v-if="model != 'add'" label="家属信息" name="second">
          <FamilyInfo ref="FamilyInfoRef" :model="model"></FamilyInfo>
        </el-tab-pane>
        <el-tab-pane v-if="model != 'add'" label="合同信息" name="third">
          <!-- <FamilyInfo ref="FamilyInfoRef" :model="model"></FamilyInfo> -->
          <Contract ref="contractRef" :row="form" :model="model"></Contract>
        </el-tab-pane>
        <el-tab-pane v-if="model == 'view'" label="健康信息" name="fourth">
          <HealthManage ref="healthManageRef" :row="form" :model="model"></HealthManage>
        </el-tab-pane>
        <el-tab-pane v-if="model == 'view'" label="设备信息" name="five">
          <Equipment ref="equipmentRef" :row="form"></Equipment>
        </el-tab-pane>
        <el-tab-pane v-if="model == 'view'" label="嘱托信息" name="six">
          <Entrust ref="entrustRef" :row="form"></Entrust>
        </el-tab-pane>
        <el-tab-pane v-if="model == 'view'" label="咨询登记" name="seven">
          <Consult ref="consultRef" :row="form"></Consult>
        </el-tab-pane>
        <el-tab-pane v-if="model == 'view'" label="服务工单" name="eight">
          <WorkOrder ref="workOrderRef" :row="form"></WorkOrder>
        </el-tab-pane>
        <!-- <el-tab-pane label="健康信息登记" name="third">
          <HealthInfo ref="HealthInfoRef" :model="model"></HealthInfo>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="护理任务设置" name="fourth">
          <NursingTasksInfo ref="NursingTasksInfoRef"></NursingTasksInfo>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="体检信息" name="fourth">
          <MedicalTestInfo ref="MedicalTestInfoRef" :model="model"></MedicalTestInfo>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="收费标准" name="five">
          <CateringBedsInfo ref="CateringBedsInfoRef" @success="cateringBedsInfoSuccess" :model="model"
            :nursinghomeId="nursinghomeId" :row="form" :nursinghomeName="nursinghomeName"></CateringBedsInfo>
        </el-tab-pane> -->

        <!-- <el-tab-pane label="附件管理" name="six">
          <DocumentInfo ref="DocumentInfoRef"></DocumentInfo>
        </el-tab-pane> -->
      </el-tabs>
      <div style="    text-align: right;" v-if="model != 'view'">
        <el-button type="primary" icon="el-icon-circle-plus-outline" v-if="activeName == 'first'" @click="saveRecord" size="small">
          {{ model == 'add' ? '提交' : '修改' }}
        </el-button>
        <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
          取消
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import BaseInfo from './baseInfo.vue';
import FamilyInfo from './familyInfo.vue';
import Contract from './contract.vue';
import HealthInfo from './healthInfo.vue';
import NursingTasksInfo from './nursingTasksInfo.vue';
import CateringBedsInfo from './cateringBedsInfo.vue';
import DocumentInfo from './documentInfo.vue';
import MedicalTestInfo from './medicalTestInfo.vue';
import Equipment from './equipment.vue';
import Entrust from './entrust.vue';
import Consult from './consult.vue';
import WorkOrder from './workOrder.vue';
import HealthManage from '../../nursingHome/healthData/healthManage';

import { removeStore, getStore } from '@/util/store';
import { setStore } from '@/util/store';
import {
  getMatetial,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
} from '../api/serveItemManage';
export default {
  components: { BaseInfo, FamilyInfo,Contract, HealthInfo, NursingTasksInfo, CateringBedsInfo, DocumentInfo, MedicalTestInfo, HealthManage, Equipment, Entrust, Consult, WorkOrder },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    nursinghomeName: {},
    isBed: {
      default: false,
    },
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      activeFlag: true,
      projectList: [],
      activeName: 'first',
      form: {
        nursinghomeId: '',
        name: '',
        // birthday: '123',
        idNumber: ''
      },
      formRules: {
        // idNumber: [{ required: true, message: '物料名称不能为空', trigger: 'change' }],
        // consumableName: [{ required: true, message: '物料名称不能为空', trigger: 'change' }],
        // nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
        // consumableCode: [{ required: true, message: '物料编码不能为空', trigger: 'change' }],
      },
      matetialList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() { },
  watch: {},
  methods: {
    successHandler() {
      this.$emit('stepsuccess');
    },
    initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
      });
      if (this.model == 'add') {
        this.form.nursinghomeId = this.row.nursinghomeId;
        this.form.nursinghomeName = this.row.nursinghomeName;
        //  getMatetial({ nursinghomeId: this.form.nursinghomeId }).then((res) => {
        //   this.matetialList = res.data;

        //   if (this.matetialList.length > 0) {
        //     this.form.consumableId = this.matetialList[0].id;
        //   }
        // });
        //通过物料id获取仓库数据
      } else {
        this.form = this._.cloneDeep(this.row);;
        let self = this;
        console.log(self.form, "self.form============>");
        console.log(self.form.elderlyId, "self.form.elderlyId============>");
        this.form.nursinghomeName = this.nursinghomeName;
        setStore({
          name: 'elderId',
          content: this.isBed ? self.form.liveUserId : self.form.id
        })
      }
    },
    saveRecord() {
      // if(){

      // }
      let self = this;
      console.log("this.activeName===========>", this.activeName);
      if (this.activeName === 'first') {
        this.activeFlag = this.$refs.baseInfoRef.saveRecord(() => {

          // this.activeName = 'second'
          // setTimeout(()=>{
            if (this.model == 'edit') {
              self.activeName = 'second'
              self.$refs.FamilyInfoRef.initData()
            } else {
              this.$emit('success');
            }

          // })
        })
      }
      // if (this.activeName === 'second') {
      //   // setTimeout(()=>{
      //   this.activeName = 'third'
      //   this.$refs.contractRef.initData()
      //   // })
      //   // this.activeFlag = this.$refs.FamilyInfoRef.saveRecord()
      // }

      // if (this.activeName === 'third') {
      //   this.activeFlag = this.$refs.HealthInfoRef.saveRecord(() => {

      //     // this.activeName = 'second'
      //     // setTimeout(()=>{
      //     self.activeName = 'fourth'
      //     self.$refs.MedicalTestInfoRef.initData()
      //     // })
      //   })
      //   // this.$refs.HealthInfoRef.initData()
      //   // this.activeName = 'fourth'
      // }
      // if (this.activeName === 'fourth') {
      //   this.activeFlag = this.$refs.MedicalTestInfoRef.saveRecord(() => {

      //     // this.activeName = 'second'
      //     // setTimeout(()=>{
      //     self.activeName = 'five'
      //     self.$refs.CateringBedsInfoRef.initData()
      //     // })
      //   })
      //   // this.$refs.MedicalTestInfoRef.initData()
      //   // this.activeName = 'five'
      // }
      // if (this.activeName === 'five') {
      //   this.activeFlag = this.$refs.CateringBedsInfoRef.saveRecord()
      //   // this.$refs.CateringBedsInfoRef.initData()
      // }

    },
    tabsBefore() {
      console.log(this.activeName)
      console.log(getStore({ name: 'elderId' }));

      // this.activeFlag = this.$refs.baseInfoRef.saveRecord()
      if (getStore({ name: 'elderId' }) && (getStore({ name: 'elderId' }) + '') !== 'undefined') {
        return true;
      } else {
        return false;
      }
      if (this.activeFlag) {
        return true
      } else {
        return false
      }
    },
    handleClick() {

      if (this.activeName === 'first') {
        this.$refs.baseInfoRef.initData()
      }
      if (this.activeName === 'second') {
        this.$refs.FamilyInfoRef.initData()
      }
      if (this.activeName === 'third') {
        this.$refs.contractRef.onLoad()
      }
      if (this.activeName === 'fourth') {
        this.$refs.healthManageRef.handleClick()
      }
      if (this.activeName === 'five') {
        this.$refs.equipmentRef.onLoad()
      }

      if (this.activeName === 'six') {
        this.$refs.entrustRef.initData()
      }

      if (this.activeName === 'seven') {
        this.$refs.consultRef.onLoad()
      }

      if (this.activeName === 'eight') {
        this.$refs.workOrderRef.onLoad()
      }
      console.log(this.activeName)
    },
    cateringBedsInfoSuccess() {
      removeStore({
        name: 'elderId'
      });
      this.$emit('success');
    },
    cancleRecord() {
      removeStore({
        name: 'elderId'
      });
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

::v-deep .el-col-8 {
  height: 54px;
}
</style>
